import axios from '../../utils/axiosConfig';


import {
  DISBURSEMENT_LIST_REQUEST,
  DISBURSEMENT_LIST_SUCCESS,
  DISBURSEMENT_LIST_FAIL,
  DISBURSEMENT_CREATE_REQUEST,
  DISBURSEMENT_CREATE_SUCCESS,
  DISBURSEMENT_CREATE_FAIL,
  DISBURSEMENT_DETAILS_REQUEST,
  DISBURSEMENT_DETAILS_SUCCESS,
  DISBURSEMENT_DETAILS_FAIL,
  DISBURSEMENT_UPDATE_REQUEST,
  DISBURSEMENT_UPDATE_SUCCESS,
  DISBURSEMENT_UPDATE_FAIL,
  DISBURSEMENT_DELETE_REQUEST,
  DISBURSEMENT_DELETE_SUCCESS,
  DISBURSEMENT_DELETE_FAIL,
} from "../constants/disbursementConstants";

// Fetch all disbursements
export const listDisbursements = (filters = {}) => async (dispatch) => {
  try {
    dispatch({ type: DISBURSEMENT_LIST_REQUEST });

    // Build query string from filters
    const queryParams = new URLSearchParams();
    if (filters.owner) queryParams.append('owner', filters.owner);
    if (filters.case) queryParams.append('case', filters.case);
    if (filters.isBilled !== undefined) queryParams.append('isBilled', filters.isBilled);
    if (filters.type) queryParams.append('type', filters.type);
    if (filters.startDate) queryParams.append('startDate', filters.startDate);
    if (filters.endDate) queryParams.append('endDate', filters.endDate);
    if (filters.search) queryParams.append('search', filters.search);
    
    const queryString = queryParams.toString();
    const url = queryString ? `/api/disbursements?${queryString}` : '/api/disbursements';

    const { data } = await axios.get(url);

    console.log("data", data);

    dispatch({ type: DISBURSEMENT_LIST_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: DISBURSEMENT_LIST_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Fetch disbursements by case ID
export const getDisbursementsByCaseId = (caseId) => async (dispatch) => {
  try {
    dispatch({ type: DISBURSEMENT_LIST_REQUEST });

    // First, get all disbursements
    const { data } = await axios.get("/api/disbursements");
    
    // Filter for the specific case ID
    // Note: This could be optimized with a backend API that filters directly
    const filteredData = data.filter(disbursement => disbursement.case?._id === caseId);

    dispatch({ type: DISBURSEMENT_LIST_SUCCESS, payload: filteredData });
  } catch (error) {
    dispatch({
      type: DISBURSEMENT_LIST_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Create a disbursement
export const createDisbursement = (disbursementData) => async (dispatch) => {
  try {
    dispatch({ type: DISBURSEMENT_CREATE_REQUEST });

    console.log("Creating disbursement with data:", disbursementData);

    // Ensure the date is properly formatted
    let formattedData = { ...disbursementData };
    if (formattedData.date && formattedData.date instanceof Date) {
      formattedData.date = formattedData.date.toISOString().split('T')[0];
    }

    const { data } = await axios.post("/api/disbursements", formattedData);
    console.log("Disbursement created successfully:", data);

    dispatch({ type: DISBURSEMENT_CREATE_SUCCESS, payload: data });
  } catch (error) {
    console.error("Error creating disbursement:", error);
    dispatch({
      type: DISBURSEMENT_CREATE_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const getDisbursementDetails = (id) => async (dispatch) => {
    try {
      dispatch({ type: DISBURSEMENT_DETAILS_REQUEST });
  
      const { data } = await axios.get(`/api/disbursements/${id}`);
  
      dispatch({ type: DISBURSEMENT_DETAILS_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: DISBURSEMENT_DETAILS_FAIL,
        payload: error.response?.data?.message || error.message,
      });
    }
  };

  export const updateDisbursement = (id, disbursementData) => async (dispatch) => {
    try {
      dispatch({ type: DISBURSEMENT_UPDATE_REQUEST });
  
      const { data } = await axios.put(`/api/disbursements/${id}`, disbursementData);
  
      dispatch({ type: DISBURSEMENT_UPDATE_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: DISBURSEMENT_UPDATE_FAIL,
        payload: error.response?.data?.message || error.message,
      });
    }
  };

  // client/src/redux/actions/disbursementActions.js - add this function
export const updateIsBilledDisbursements = (disbursementIds, isBilled, invoiceId) => async (dispatch) => {
  try {
    console.log(disbursementIds, isBilled, invoiceId);
    await axios.put('/api/disbursements', { disbursementIds, isBilled, invoiceId });
  } catch (error) {
    console.error(error);
  }
};

// Delete a disbursement
export const deleteDisbursement = (id) => async (dispatch) => {
  try {
    dispatch({ type: DISBURSEMENT_DELETE_REQUEST });

    await axios.delete(`/api/disbursements/${id}`);

    dispatch({ type: DISBURSEMENT_DELETE_SUCCESS });
  } catch (error) {
    dispatch({
      type: DISBURSEMENT_DELETE_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};